module.exports = __webpack_public_path__ + "static/media/shopping-bag.06238170.svg";